module.exports = __webpack_public_path__ + "img/document-icon.7dbaff33.svg";